/**
 * This is just a prettier way of determining if the ENV is production or not. Mainly used for the phone module. Spares us string manipulation and comparison wherever it is used.
 */
export const IS_PROD = process.env.REACT_APP_ENV.toLowerCase().includes('prod');
export const REGION = process.env.REACT_APP_REGION;